'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import { AlertDialog } from '@workspace/ui/components/custom/alert-dialog';

interface CancelTransactionSuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CancelTransactionSuccessDialog({
  open,
  onOpenChange,
}: CancelTransactionSuccessDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={onOpenChange}
      variant="success"
      title="Transaction cancelled"
      description="This transaction has been cancelled. You can still view the transaction details."
    >
      <Button variant="primary" className="w-full" onClick={() => onOpenChange(false)}>
        Close
      </Button>
    </AlertDialog>
  );
}
